"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const utilities_1 = require("jsAssets/utilities");
const material_1 = require("@mui/material");
const lodash_1 = require("lodash");
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const helper_1 = require("../../../../../reviews/helper");
const constants_1 = require("../../../../slice/sliceTemplate/constants");
const canEditTemplate = (permissions) => {
    if (helper_1.REVIEWS_TEMPLATE_ADMIN_PERMISSION === 'y') {
        return true;
    }
    const isUserEditTemplate = (0, utilities_1.camelizeKeys)(permissions).some((permission) => permission.permission === constants_1.TEMPLATE_PERMISSION.edit &&
        permission.resourceType === constants_1.TEMPLATE_RESOURCE.user &&
        permission.resourceId === Number(helper_1.USER.id));
    return isUserEditTemplate;
};
const OptionSelectTemplate = (props) => {
    const { label, isLoading, isLoadingComponent, data, innerProps, selectProps, } = props;
    const [permissionsTemplate, setPermissionsTemplate] = (0, react_1.useState)([]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if ((_a = data === null || data === void 0 ? void 0 : data.raw) === null || _a === void 0 ? void 0 : _a.permissions) {
            setPermissionsTemplate((_b = data === null || data === void 0 ? void 0 : data.raw) === null || _b === void 0 ? void 0 : _b.permissions);
        }
    }, [data]);
    const handleSelectTemplate = (0, react_1.useCallback)((action) => {
        if ((0, lodash_1.isFunction)(selectProps === null || selectProps === void 0 ? void 0 : selectProps.onChange) && data) {
            selectProps === null || selectProps === void 0 ? void 0 : selectProps.onChange(data, {
                action: 'select-option',
                name: action,
                option: undefined,
            });
        }
    }, [data]);
    return (react_1.default.createElement(react_1.default.Fragment, null, isLoading && !isLoadingComponent ? (react_1.default.createElement(material_1.Skeleton, { className: styles_modules_less_1.default.skeletonOption })) : (react_1.default.createElement("div", { className: styles_modules_less_1.default.templates__item, onClick: () => handleSelectTemplate('select'), ...innerProps },
        react_1.default.createElement("div", { className: styles_modules_less_1.default.item__root },
            react_1.default.createElement("span", { className: styles_modules_less_1.default.item__content }, label),
            react_1.default.createElement("i", { className: (0, clsx_1.default)(styles_modules_less_1.default.item__icon, canEditTemplate(permissionsTemplate) &&
                    styles_modules_less_1.default['item__icon--available'], 'fal fa-edit'), onClick: (e) => {
                    e.stopPropagation();
                    handleSelectTemplate('edit');
                } }))))));
};
exports.default = OptionSelectTemplate;
